module.exports = __webpack_public_path__ + "img/energy-and-clean-technology.65e9eeb3.svg";